<template>
  <div>
    <headerNotice routerName="批量发货"></headerNotice>
    <!-- 发货表格 -->
    <div class="dataTable" v-loading="loading">
      <el-table class="tableBox" :data="orderList" style="width: 100%">
        <el-table-column align="center" prop="orderCode" label="订单编号" width="200"></el-table-column>
        <el-table-column align="center" prop="recipient" label="收货人" width="100"></el-table-column>
        <el-table-column align="center" prop="phone" label="手机号码" width="150"></el-table-column>
        <el-table-column align="center" prop="site" label="收货地址"></el-table-column>
        <el-table-column align="center" label="发货点">
          <template slot-scope="scope">
            <el-select v-model="scope.row.deliveryPointID" @change='deliveryPointChange(scope.$index)' placeholder="请选择发货点">
              <el-option
                v-for="item in deliveryList"
                :key="item.deliveryPointID"
                :label="item.deliveryPointName"
                :value="item.deliveryPointID"
              ></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column align="center" label="物流公司">
          <template slot-scope="scope">
            <el-select v-model="scope.row.logisticsID" placeholder="请选择物流公司">
              <el-option
                v-for="item in logisticsList"
                :key="item.logisticsID"
                :label="item.logisticsName"
                :value="item.logisticsID"
              ></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column align="center" label="物流单号">
          <template slot-scope="scope">
            <el-input v-model="scope.row.expressNo" clearable></el-input>
          </template>
        </el-table-column>
      </el-table>
      <!-- 多选操作 -->
      <div style="margin-top: 20px;text-align:center;">
        <el-button type="info" @click="cancel">返回</el-button>
        <el-button type="primary" :loading="btnLoading" @click="updateAdminOrderStatus">确定</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import headerNotice from "./../../components/common/headerNotice.vue";
export default {
  data() {
    return {
      orderIDArr: [],
      orderList: [],
      logisticsList: [],
      loading: false,
      btnLoading: false,
      houseIndex: 0,
      deliveryList: []
    };
  },
  components: {
    headerNotice
  },
  mounted() {
    if (sessionStorage.getItem("orderIDArr")) {
      this.orderIDArr = sessionStorage.getItem("orderIDArr");
      this.orderIDArr = this.orderIDArr.split(",");
      this.getDatas();
      this.getAllLogistics()
    }
  },
  methods: {
    deliveryPointChange(index) {
      if(this.orderList[index].logisticsID) {
        this.orderList[index].logisticsID = ''
      }
    },
    //获取列表数据
    getDatas() {
      let self = this;
      self.loading = true;
      $http.POST({
        url:
          this.$store.state.apiUrl +
          "/api/services/app/AdminIntegralExchange/IntegralDeliverList",
        data: {
          orderIDs: this.orderIDArr
        },
        success(res) {
          self.orderList = res;
          self.loading = false;
          self.getDeliveryByID()
        },
        fail(res) {
          self.loading = false;
        }
      });
    },
    //取消
    cancel() {
      this.$router.back();
    },
    // 获取物流公司
    getAllLogistics(params) {
      let self = this;
    //   self.areaLoading = false;
      $http.GET({
        url:
          this.$store.state.apiUrl +
          "/api/services/app/AdminLogistics/GetAllLogistics",
        params: params,
        success(res) {
        self.logisticsList = res
        },
        fail(res) {
        //   self.areaLoading = false;
        }
      });
    },
     // 获取发货点
    getDeliveryByID(params) {
      let self = this;
    //   self.areaLoading = false;
      $http.GET({
        url:
          this.$store.state.apiUrl +
          "/api/services/app/AdminIntegralExchange/GetDeliveryByID",
        params: params,
        success(res) {
        self.deliveryList = res
        for(let i = 0; i < self.orderList.length; i++) {
          self.$set(self.orderList[i], 'deliveryPointID', res[0].deliveryPointID)
        }
        },
        fail(res) {
        //   self.areaLoading = false;
        }
      });
    },
    //发货确认
    updateAdminOrderStatus() {
      let self = this;
      let submitOrder = [];
      self.btnLoading = true;
      self.orderList.forEach((ele, index) => {
        submitOrder.push({
          orderID: ele.orderID,
          logisticsID: ele.logisticsID,
          expressNo: ele.expressNo,
          deliveryPointID: ele.deliveryPointID
        });
      });
      $http.PUT({
        url:
          this.$store.state.apiUrl +
          "/api/services/app/AdminIntegralExchange/UpdateAdminOrderStatus",
        data: {
          delivers: submitOrder
        },
        success(res) {
          self.$message({
            message: "发货成功！",
            type: "success"
          });
          self.getDatas();
          self.btnLoading = false;
        },
        fail(res) {
          self.btnLoading = false;
        }
      });
    }
  }
};
</script>

<style lang='scss' scoped>
.dataTable {
  margin: 20px 40px;
  .tableBox {
    border: 1px solid #c5c5c5;
  }
}
</style>